import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const obtenerTurnosPorPersona = async ({ token, id, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.TURNOS}/${id}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default obtenerTurnosPorPersona;